import React, { useState } from 'react';

export default function StepServices({ services, onChange, onBack, onNext, loading }) {
  const [newService, setNewService] = useState('');

  const addService = () => {
    const v = newService.trim();
    if (v && !services.includes(v)) {
      onChange([...services, v]);
      setNewService('');
    }
  };

  const removeService = (i) => onChange(services.filter((_, idx) => idx !== i));

  const updateService = (i, val) => {
    const updated = [...services];
    updated[i] = val;
    onChange(updated);
  };

  const valid = services.filter(s => s.trim()).length > 0;

  return (
    <div>
      <div className="page-header">
        <div className="page-title">Services</div>
        <div className="page-sub">Enter every service this client offers. The AI will generate keyword variations for each one.</div>
      </div>

      <div className="card">
        <div className="card-title">Client services</div>
        <div className="card-sub">
          Add each service separately. Include sub-services where relevant — e.g. "Carpet cleaning" and "Upholstery cleaning" as separate entries rather than one combined entry.
        </div>

        {services.map((s, i) => (
          <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
            <input
              type="text"
              value={s}
              placeholder="e.g. Carpet cleaning"
              onChange={e => updateService(i, e.target.value)}
            />
            <button className="btn btn-sm btn-danger" onClick={() => removeService(i)}>Remove</button>
          </div>
        ))}

        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
          <input
            type="text"
            placeholder="Add a service..."
            value={newService}
            onChange={e => setNewService(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && addService()}
            style={{ flex: 1 }}
          />
          <button className="btn btn-sm" onClick={addService} disabled={!newService.trim()}>
            + Add
          </button>
        </div>

        {services.length === 0 && (
          <div className="alert alert-warning" style={{ marginTop: 12 }}>
            Add at least one service to continue.
          </div>
        )}

        <div className="card-divider" />
        <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>
          <strong style={{ color: 'var(--gray-700)' }}>Tips:</strong> Break services into specific sub-services for better results.
          A cleaning company should list "Carpet cleaning", "Upholstery cleaning", "Oven cleaning" etc. separately.
          A builder should list "Loft conversions", "House extensions", "Kitchen fitting" etc.
        </div>
      </div>

      <div className="actions">
        <button className="btn" onClick={onBack}>← Back</button>
        <button className="btn btn-primary" onClick={onNext} disabled={!valid || loading}>
          {loading ? <><span className="spinner" /> Generating keywords…</> : 'Generate keyword ideas →'}
        </button>
      </div>
    </div>
  );
}
